const reducer = state => {
  return {
    ...state,
    giftCardToken: null,
    giftCardValidationNonce: null,
    waiting: false,
  };
};

export default reducer;
